export type PaginationParams = {
    totalPages: number,
    totalCount: number,
    currentPage: number,
    pageSize: number,
};

export const SMALL = 2 as const;
export const NORMAL = 3 as const;

export const PaginationRangeTypes: {[key: string]: typeof SMALL | typeof NORMAL} = {
    SMALL,
    NORMAL,
};

type ValuesOf<T> = T[keyof T];
export type PaginationRangeType = ValuesOf<typeof PaginationRangeTypes>;
